import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTenderData } from 'src/models/procurements/Tender/hooks';
import { TenderSubCatName, TenderBoxMode } from 'src/models/procurements/Tender/types';
import { TenderBox, TenderSubCat } from 'src/shared';
import { isAddition } from 'src/models/procurements/Tender/helpers';
import { isNotUndefined } from 'src/helpers';
import { Translations } from 'src/lib/I18nService/types';

export const LocationSubCat: FC = () => {
  const { t: tenderT } = useTranslation(Translations.procurements);
  const { data } = useTenderData();
  const isEditable = !!data?.isEditable;
  const subCat = useMemo(() => data?.generalCat[TenderSubCatName.Location], [data]);
  const locationBox = useMemo(
    () =>
      subCat && subCat.boxes.locationBoxes && subCat.boxes.locationBoxes.length
        ? subCat.boxes.locationBoxes[0]
        : undefined,
    [subCat]
  );
  const nutsCodesBox = useMemo(
    () =>
      subCat && subCat?.boxes.placeOfPerformanceNutsCode && subCat.boxes.placeOfPerformanceNutsCode.length
        ? subCat.boxes.placeOfPerformanceNutsCode[0]
        : undefined,
    [subCat]
  );
  const locationBoxes = useMemo(() => [locationBox, nutsCodesBox].filter(isNotUndefined), [locationBox, nutsCodesBox]);

  const isAdditionLocation = useMemo(
    () => isAddition(subCat?.boxes.locationBoxes) || isAddition(subCat?.boxes.placeOfPerformanceNutsCode),
    [subCat]
  );

  return (
    <>
      {!!subCat && locationBoxes && (
        <TenderSubCat subCat={subCat}>
          {locationBoxes && (
            <TenderBox
              boxes={locationBoxes}
              title={tenderT('Place of performance')}
              as={TenderBoxMode.Collection}
              isInfo={isAdditionLocation}
              isEditable={isEditable}
              isFirstField
            />
          )}
        </TenderSubCat>
      )}
    </>
  );
};

export default LocationSubCat;
